export interface RangeBegin {
    begin: number;
    beginVs: number;
}

export interface RangeCustom {
    begin: number;
    end: number;
    beginVs: number;
    endVs: number;
}

export interface EntryDetail {
    nbPerson: number;
    passages: number;
    nbGroups: number;
    wifiVisit: number;
    wifiPassage: number;
}

export interface EntriesData {
    [entryName: string]: EntryDetail;
}

export interface PrincipalDatasProperties {
    nbPerson: number;
    nbGroups: number;
    passages: number;
    attractivenessRate: number;
    attractivityWifi: number;
    turnover: number;
    transformationRate: number;
    entries: EntriesData;
}

export interface PrincipalData {
    current: PrincipalDatasProperties;
    versus: PrincipalDatasProperties;
    comparison: PrincipalDatasProperties;
}
